import ErrorIcon from "@mui/icons-material/Error";

export default function PageNotFound() {
  return (
    <div className="page-loading">
      <p className="flex justify-center items-center"><ErrorIcon /> </p>
      <h1 className="text-xl font-semibold">404 Page not found</h1>
    </div>
  );
}